/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    blockquote: "blockquote",
    p: "p",
    a: "a",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "\"innerRef\""
      }), " prop"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["The ", _jsx(_components.code, {
          children: "\"innerRef\""
        }), " prop was removed in styled-components v4 in favor of the ", _jsxs(_components.a, {
          href: "https://reactjs.org/docs/forwarding-refs.html",
          children: ["React 16 ", _jsx(_components.code, {
            children: "forwardRef"
          }), " API"]
        }), ". Just use the normal ", _jsx(_components.code, {
          children: "ref"
        }), " prop instead."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Passing a ", _jsx(_components.code, {
        children: "ref"
      }), " prop to a styled component will give you an instance of\nthe ", _jsx(_components.code, {
        children: "StyledComponent"
      }), " wrapper, but not to the underlying DOM node.\nThis is due to how refs work.\nIt's not possible to call DOM methods, like ", _jsx(_components.code, {
        children: "focus"
      }), ", on our wrappers directly."]
    }), "\n", _jsxs(_components.p, {
      children: ["To get a ref to the actual, wrapped DOM node, pass the callback to the ", _jsx(_components.code, {
        children: "innerRef"
      }), " prop instead."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["We don't support string refs (i.e. ", _jsx(_components.code, {
          children: "innerRef=\"node\""
        }), "), since they're already deprecated in React."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["This example uses ", _jsx(_components.code, {
        children: "innerRef"
      }), " to save a ref to the styled input and focuses it once the user\nhovers over it."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const Input = styled.input`\n  padding: 0.5em;\n  margin: 0.5em;\n  color: #BF4F74;\n  background: papayawhip;\n  border: none;\n  border-radius: 3px;\n`\n\nclass Form extends React.Component {\n  render() {\n    return (\n      <Input\n        placeholder=\"Hover here...\"\n        innerRef={x => {\n          this.input = x\n        }}\n        onMouseEnter={() => this.input.focus()}\n      />\n    )\n  }\n}\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
